import React from 'react';
import { MailIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="w-full bg-slate-900 text-slate-400 px-6 py-12 border-t border-slate-800" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-47">
          <div data-id="element-48">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-49">
              Pomelo Services
            </h3>
            <p className="text-sm leading-relaxed" data-id="element-50">
              Secure payment solutions for international travelers. Lock in the
              best rates and protect your transactions.
            </p>
          </div>
          <div data-id="element-51">
            <h4 className="text-white font-semibold mb-4" data-id="element-52">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-53">
              <li data-id="element-54">
                <Link to="/terms" className="hover:text-blue-400 transition-colors" data-id="element-55">
                  Terms and Conditions
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/privacy" className="hover:text-blue-400 transition-colors" data-id="element-57">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-58">
            <h4 className="text-white font-semibold mb-4" data-id="element-59">Contact</h4>
            <div className="space-y-3 text-sm" data-id="element-60">
              <div className="flex items-center gap-2" data-id="element-61">
                <MailIcon className="w-4 h-4" data-id="element-62" />
                <a href="mailto:enquiries@pomeloservices.uk" className="hover:text-blue-400 transition-colors" data-id="element-63">
                  enquiries@pomeloservices.uk
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8" data-id="element-64">
          <div className="text-xs space-y-2" data-id="element-65">
            <p data-id="element-66">
              Pomelo Services Ltd is a limited liability company registered in
              England and Wales, number 13810984.
            </p>
            <p data-id="element-67">
              Registered office address: Kemp House, 160 City Road, London,
              United Kingdom.
            </p>
            <p className="pt-4 text-slate-500" data-id="element-68">
              © {new Date().getFullYear()} Pomelo Services Ltd. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}